/* eslint-disable react/prop-types */
import type {ComponentProps} from 'react';
import React, {Fragment, PureComponent, useRef} from 'react';
import {Keyboard, Platform} from 'react-native';
import Config from 'react-native-config';
import {createStackNavigator} from '@react-navigation/stack';
import {defer} from 'lodash/fp';

import KeyboardAvoidingView from '/component/layout/KeyboardAvoidingView';
import VisitWebsitePopover from '/component/partial/VisitWebsitePopover';
import {EVENT_NAMES, SCREEN_NAMES, USER_DECISION} from '/enum/tealium.enum';
import {createPopoverProvider} from '/provider/PopoverProvider';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

import {styles} from './Login.style';
import {LoginForm} from './LoginForm';
const RESET_PASSWORD_URL = Config.RESET_PASSWORD_URL;

interface LoginProps {
  currentScreen: string;
}
interface PopoverProviderType {
  popoverShow: (Component: React.ComponentType<any>, payload: any) => void;
  popoverProvider: React.Provider<any>;
  Consumer: React.ComponentType<any>;
}
type KeyboardAvoidingViewProps = ComponentProps<typeof KeyboardAvoidingView>;

class Login extends PureComponent<LoginProps> {
  private popoverProvider: PopoverProviderType;

  constructor(props: LoginProps) {
    super(props);
    // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
    this.popoverProvider = createPopoverProvider({
      onDismiss: () =>
        getTealiumUtilDefaultInstance().generateTrackEvent({
          eventName: EVENT_NAMES.exitLink,
        })({
          screenName: SCREEN_NAMES.loginScreen,
          destinationLink: RESET_PASSWORD_URL,
          userDecision: USER_DECISION.false,
        }),
    });
  }

  getLoginFormScreenComponent() {
    const {Consumer: PopoverConsumer} = this.popoverProvider;

    return () => {
      const ScreenComponent = ({popoverShow}: {popoverShow: Function}) => {
        const handleForgotPasswordRef = useRef((payload: any) => {
          Keyboard.dismiss();
          defer(() => popoverShow(VisitWebsitePopover, payload));
        });

        return (
          <LoginForm
            testID="login-form"
            onShowForgotPassword={handleForgotPasswordRef.current}
          />
        );
      };

      return (
        <PopoverConsumer>
          {({popoverShow}: any) => (
            <ScreenComponent popoverShow={popoverShow} />
          )}
        </PopoverConsumer>
      );
    };
  }

  getLoginStackComponent() {
    const LoginStackNavigator = createStackNavigator();
    const LoginFormScreen = this.getLoginFormScreenComponent();

    return () => (
      <LoginStackNavigator.Navigator
        initialRouteName="authorization-form"
        screenOptions={{headerShown: false, cardStyle: styles.container}}>
        <LoginStackNavigator.Screen
          name="authorization-form"
          component={LoginFormScreen}
        />
      </LoginStackNavigator.Navigator>
    );
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
    const {Provider: PopoverProvider} = this.popoverProvider;
    const LoginStack = this.getLoginStackComponent();

    const FragmentWrapper: React.FC<KeyboardAvoidingViewProps> = ({
      children,
    }) => <>{children}</>;

    const ViewContainer = Platform.select({
      ios: KeyboardAvoidingView,
      android: FragmentWrapper,
      web: FragmentWrapper, // Web handles keyboard via browser/CSS
    }) as React.ElementType;

    return (
      <PopoverProvider>
        <ViewContainer>
          <LoginStack />
        </ViewContainer>
      </PopoverProvider>
    );
  }
}

export {Login};
